// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__bfc {
  display: flex;
  flex-direction: column;
}

.transparencyLink__b19 {
  color: var(--ring-action-link-color);
}

.actionsContainer__a3a {
  margin-top: calc(2 * var(--ring-unit));
}

.editContainer__be4 {
  margin-top: calc(3 * var(--ring-unit));
  display: flex;
  flex-direction: column;
}

.agreementTextWrapper__f40 {
  margin: calc(2 * var(--ring-unit)) 0;

  &.editing__fe6 {
    margin-top: calc(3 * var(--ring-unit));
  }
}

.previewTitle__a90 + .agreementText__af4 {
  margin-top: var(--ring-unit);
}

.agreementText__af4 {
  position: relative;
  overflow-y: scroll;
  min-height: 20vh;
  max-height: 60vh;
  border: 1px solid var(--ring-border-disabled-color);
  border-radius: var(--ring-border-radius);
  padding: calc(1.5 * var(--ring-unit)) calc(2 * var(--ring-unit));
  background-color: var(--ring-sidebar-background-color);
  word-wrap: break-word;
}

.textEditor__eab {
  width: 100%;

  textarea {
    max-height: calc(31 * var(--ring-unit));
    overflow: auto;
  }
}

.actionButtons__ea3 {
  margin-top: calc(1.5 * var(--ring-unit));
  display: flex;
  gap: var(--ring-unit);
}

.dragOverlay__c52 {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: var(--ring-hover-background-color);
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/pages/configuration-page/data-collection/data-collection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;;EAEpC;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mDAAmD;EACnD,wCAAwC;EACxC,gEAAgE;EAChE,sDAAsD;EACtD,qBAAqB;AACvB;;AAEA;EACE,WAAW;;EAEX;IACE,uCAAuC;IACvC,cAAc;EAChB;AACF;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,8CAA8C;EAC9C,YAAY;AACd","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n}\n\n.transparencyLink {\n  color: var(--ring-action-link-color);\n}\n\n.actionsContainer {\n  margin-top: calc(2 * var(--ring-unit));\n}\n\n.editContainer {\n  margin-top: calc(3 * var(--ring-unit));\n  display: flex;\n  flex-direction: column;\n}\n\n.agreementTextWrapper {\n  margin: calc(2 * var(--ring-unit)) 0;\n\n  &.editing {\n    margin-top: calc(3 * var(--ring-unit));\n  }\n}\n\n.previewTitle + .agreementText {\n  margin-top: var(--ring-unit);\n}\n\n.agreementText {\n  position: relative;\n  overflow-y: scroll;\n  min-height: 20vh;\n  max-height: 60vh;\n  border: 1px solid var(--ring-border-disabled-color);\n  border-radius: var(--ring-border-radius);\n  padding: calc(1.5 * var(--ring-unit)) calc(2 * var(--ring-unit));\n  background-color: var(--ring-sidebar-background-color);\n  word-wrap: break-word;\n}\n\n.textEditor {\n  width: 100%;\n\n  textarea {\n    max-height: calc(31 * var(--ring-unit));\n    overflow: auto;\n  }\n}\n\n.actionButtons {\n  margin-top: calc(1.5 * var(--ring-unit));\n  display: flex;\n  gap: var(--ring-unit);\n}\n\n.dragOverlay {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background: var(--ring-hover-background-color);\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__bfc`,
	"transparencyLink": `transparencyLink__b19`,
	"actionsContainer": `actionsContainer__a3a`,
	"editContainer": `editContainer__be4`,
	"agreementTextWrapper": `agreementTextWrapper__f40`,
	"editing": `editing__fe6`,
	"previewTitle": `previewTitle__a90`,
	"agreementText": `agreementText__af4`,
	"textEditor": `textEditor__eab`,
	"actionButtons": `actionButtons__ea3`,
	"dragOverlay": `dragOverlay__c52`
};
export default ___CSS_LOADER_EXPORT___;
